import api, {
  PostApplyNewContractRequest,
  PostApplyExistingContractRequest
} from "./api";
import { ActionContext } from "vuex";
import log from "loglevel";

interface State {}

type MyActionContext = ActionContext<State, State>;

export default {
  namespaced: true,
  state: {} as State,
  getters: {},
  actions: {
    // 通常の契約
    async postApplyNewContract(
      context: MyActionContext,
      params: PostApplyNewContractRequest
    ) {
      try {
        const res = await api.postApplyNewContract(params);
        return res.data;
      } catch (error) {
        log.error("postContractDefault error:", error);
        throw error;
      }
    },
    async postApplyExistingContract(
      context: MyActionContext,
      params: PostApplyExistingContractRequest
    ) {
      try {
        const res = await api.postApplyExistingContract(params);
        return res.data;
      } catch (error) {
        log.error("postContractDefault error:", error);
        throw error;
      }
    },

    //PAINT用のアクティベーションコード画面の契約
    // 通常の契約
    async postApplyNewContractForPaint(
      context: MyActionContext,
      params: PostApplyNewContractRequest
    ) {
      try {
        const res = await api.postApplyNewContractForPaint(params);
        return res.data;
      } catch (error) {
        log.error("postApplyNewContractForPaint error:", error);
        throw error;
      }
    },
    async postApplyExistingContractForPaint(
      context: MyActionContext,
      params: PostApplyExistingContractRequest
    ) {
      try {
        const res = await api.postApplyExistingContractForPaint(params);
        return res.data;
      } catch (error) {
        log.error("postApplyExistingContractForPaint error:", error);
        throw error;
      }
    },
    //Ver 2.0 拡張
    async postPerpetualNewLicense(
      context: MyActionContext,
      params: PostApplyNewContractRequest
    ) {
      try {
        const res = await api.postPerpetualNewLicense(params);
        return res.data;
      } catch (error) {
        log.error("postPerpetualNewLicense error:", error);
        throw error;
      }
    },
    async postUpdatepassApplyNewContract(
      context: MyActionContext,
      params: PostApplyNewContractRequest
    ) {
      try {
        const res = await api.postUpdatepassApplyNewContract(params);
        return res.data;
      } catch (error) {
        log.error("postUpdatepassApplyNewContract error:", error);
        throw error;
      }
    },
    async postUpdatepassApplyExistingContract(
      context: MyActionContext,
      params: PostApplyExistingContractRequest
    ) {
      try {
        const res = await api.postUpdatepassApplyExistingContract(params);
        return res.data;
      } catch (error) {
        log.error("postUpdatepassApplyExistingContract error:", error);
        throw error;
      }
    }
  },
  mutations: {}
};
